/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges, OnInit} from '@angular/core';

@Component({
  standalone: false,
  selector: 'ad-status-label',
  template: `
    <span class="label {{labelClass}}">{{ translation }}</span>
    <span
      *ngFor="let creativeType of creativeTypesRequestedInLastDay"
      class="resourceLabel label label-info creativeTypeLabel"
    >{{ creativeType }}</span>
  `,
  styles: [`
    .creativeTypeLabel {
      margin-left: 1ex;
    }
  `]
})
export class AdStatusLabelComponent implements OnInit, OnChanges {
  labelClass: any;
  translation: string;
  @Input() requestedInLastDay: boolean;
  @Input() creativeTypesRequestedInLastDay: string[] = [];

  constructor() {
  }

  ngOnInit(): void {
    this.updateLabel();
  }

  ngOnChanges(): void {
    this.updateLabel();
  }

  private updateLabel(): void {
    this.labelClass = this.requestedInLastDay ? 'label-success' : 'label-warning';
    this.translation = this.requestedInLastDay ? 'Has Traffic' : 'No Recent Traffic';
    if (!Array.isArray(this.creativeTypesRequestedInLastDay)) {
      this.creativeTypesRequestedInLastDay = [];
    }
  }
}
